import {request} from "@/network/request";
/**
 * 添加项目概况
 * @param query
 * @returns {AxiosPromise}
 */
export function saveProjectOverview(data) {
  return request({
    url: '/gaoligong/picturevideo/saveProjectOverview',
    method: 'post',
    data: data
  })
}

/**
 * 修改
 * @param data
 * @returns {AxiosPromise}
 */
export function updateProjectOverview(data) {
  return request({
    url: '/gaoligong/picturevideo/updateProjectOverview',
    method: 'put',
    data: data
  })
}

/**
 * 删除
 * @param id
 * @returns {AxiosPromise}
 */
export function deleteProjectOverview(id) {
  return request({
    url: '/gaoligong/picturevideo/deleteProjectOverview/' + id,
    method: 'delete'
  })
}

/**
 * 查看
 * @param id
 * @returns {AxiosPromise}
 */
export function getProjectOverviewById(id) {
  return request({
    url: '/gaoligong/picturevideo/getProjectOverviewById/' + id,
    method: 'get'
  })
}

/**
 * 列表
 * @param type
 * @returns {*}
 */
export function getProjectOverviewList(type) {
  return request({
    url: '/gaoligong/picturevideo/getProjectOverviewList',
    method: 'get',
    params: { type}
  })
}
